// components/RelatedArticles.tsx
import React from 'react';
import { Img } from 'react-image';
import { urlFor } from '../app/blogs/lib/sanity';

interface RelatedArticle {
  title: string;
  smallDescription: string;
  currentSlug: string;
  titleImage: any;
}

interface Props {
  articles: RelatedArticle[];
}

const RelatedArticles: React.FC<Props> = ({ articles }) => {
  if (articles.length === 0) return null;

  return (
    <section className="mt-20">
      <h2 className="text-3xl font-bold text-center text-white mb-10">Related Articles</h2>
      <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3">
        {articles.map((post) => (
          <a
            key={post.currentSlug}
            href={`/blogs/${post.currentSlug}`}
            className="group bg-[#0f172a] rounded-xl overflow-hidden border border-gray-700 shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="h-44 overflow-hidden">
              <Img
                src={urlFor(post.titleImage).url()}
                alt={post.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-5">
              <h3 className="text-lg font-semibold text-white group-hover:text-blue-400 transition-colors duration-300">
                {post.title}
              </h3>
              <p className="text-sm text-gray-400 mt-2 mb-4 line-clamp-3">
                {post.smallDescription}
              </p>
              <span className="text-sm font-medium text-blue-500 hover:text-blue-300 transition">
                Read More →
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default RelatedArticles;

